import axios from "axios";

export const getAllZone = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${API_URL}/api/zone/get-all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener las zonas";
  }
};

export const createZoneService = async (userData) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token provided");
  try {
    const { data } = await axios.post(`${API_URL}/api/zone`, userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al crear la zona");
  }
};

export const updateZoneService = async (id, userData) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.put(`${API_URL}/api/zone/${id}`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al actualizar la zona";
  }
};

export const deleteZoneService = async (userId) => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("No hay token de autenticación");
  }

  try {
    const response = await axios.delete(`${API_URL}/api/zone/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Error al marcar la zona como eliminado";
    throw new Error(errorMessage);
  }
};
